/** Browser-only display preference; never part of a card or account payload. */
export const SHOW_MATCH_DETAILS_STORAGE_KEY = 'tcvs:review:show-match-details';

export function readShowMatchDetailsPreference(): boolean {
  try {
    return window.localStorage.getItem(SHOW_MATCH_DETAILS_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeShowMatchDetailsPreference(value: boolean): void {
  try {
    window.localStorage.setItem(SHOW_MATCH_DETAILS_STORAGE_KEY, String(value));
  } catch {
    // The in-memory choice still works when browser storage is unavailable.
  }
}
